<template>
  <base-modal class="confirmation-modal" :title="title" @close="$emit('close')">
    <div class="confirmation-modal__body">
      <div class="confirmation-modal__text" v-if="text">
        {{ text }}
      </div>
      <voxy-spinner v-if="isConfiming" :size="32" :stroke="2"></voxy-spinner>
      <voxy-button v-else class="confirmation-modal__button" view="primary" type="submit" @click="confirm">
        {{ buttonText }}
      </voxy-button>
    </div>
  </base-modal>
</template>

<script>
import { VoxyButton, VoxySpinner } from '@voxy-team/vue-voxy';

import BaseModal from '@/components/BaseModal';

export default {
  name: 'ConfirmationModal',

  components: {
    VoxyButton,
    VoxySpinner,
    BaseModal,
  },

  props: {
    title: {
      default: null,
      type: String,
    },
    text: {
      default: null,
      type: String,
    },
    buttonText: {
      default: 'OK',
      type: String,
    },
    type: {
      default: null,
      type: String,
    },
    confirmAction: {
      default: () => {},
      type: Function,
    },
  },

  data() {
    return {
      isConfiming: false,
    };
  },

  methods: {
    async confirm() {
      this.isConfiming = true;
      await this.confirmAction();

      this.isConfiming = false;
      this.$emit('close');
    },
  },
};
</script>

<style lang="scss" scoped>
.confirmation-modal {
  font-size: 1rem;

  &__body {
    text-align: center;
  }

  &__text {
    margin: 24px;
  }

  &__button {
    border-radius: 4px;

    ::v-deep .voxy-button__text {
      font-size: 14px;
      padding: 8px 18px;
    }
  }
}
</style>
